export const getAnimationClass = (position: string) => {
  switch (position) {
    case 'top-left':
      return 'animate-slide-in-from-left'
    case 'top-right':
      return 'animate-slide-in-from-right'
    case 'bottom-left':
      return 'animate-slide-in-from-left'
    case 'bottom-right':
      return 'animate-slide-in-from-right'
    case 'top-center':
      return 'animate-slide-in-from-top'
    case 'bottom-center':
      return 'animate-slide-in-from-bottom'
    default:
      return 'animate-slide-in-from-right'
  }
}
